Namespace 'Monitoring.Models.SocialContents'

class Monitoring.Models.SocialContents.InstagramBusinessDiscoveryAuthor
  constructor: (data) ->
    @data = data

  getId: ->
    @data.id

  getName: ->
    @data.name

  getUsername: ->
    @data.username

  getProfilePictureUrl: ->
    @data.profile_picture_url
